import React, { useState, Fragment } from "react";
import PropTypes from "prop-types";

const Course = (props) => {
  // const [course, setCourse] = useState(props.course);
  // const onChange = (e) => {
  //   // setCourse(e.target.value);
  //   changeNames;
  // };

  return (
    <Fragment>
      <input
        className="subject"
        value= {props.course}
        onChange={props.changeNames}
      ></input>
    </Fragment>
  );
};

Course.propTypes = {};

export default Course;
